import { SafeHtml } from '@angular/platform-browser';

export interface Family {
  active: boolean;
  canBeCreator?: boolean;
  canBeInvited?: boolean;
  creator: Member;
  duplicated: boolean;
  familyNotUnsubscribed?: boolean;
  id: string;
  inProcess?: boolean;
  invitationPending?: boolean;
  isClient?: boolean;
  isCreator?: boolean;
  isDraftStatus?: boolean;
  members: Member[];
  minorInMoreFamilies?: boolean;
  self: Member;
  signatureStatus: string;
}

// Member is used as a model both as the logged in client and as the members of a family.
export interface Member {
  birthdate: string;
  clientCode: string;
  codFamily?: string;
  consentStatus: UserFamilyConsentStatusType;
  creator: boolean;
  documentNumber: string;
  documentType: FamilyDocumentType;
  email: string;
  isEditable?: boolean;
  editableDocument?: boolean;
  name: string;
  phone: string;
  relationship?: FamilyRelationshipsType;
  relationshipDescription?: string;
  roleCode?: string;
  surname1: string;
  surname2: string;
  validate: number;
}

export type UserFamilyConsentStatusType =
  | 'CF'
  | 'DF'
  | 'NA'
  | 'NC'
  | 'PA'
  | 'PC'
  | 'RA';

export enum FamilyRelationshipsType {
  HM = 'HM', // Son
  RR = 'RR', // Partner
  TL = 'TL', // Tutored
}
export enum FamilyDocumentType {
  NIE = 'NIE',
  NIF = 'NIF',
  SD = 'SD',
}

// Information screens configuration
export interface FamilyInfoConfig {
  alert?: string | SafeHtml;
  buttons?: FamilyButton[];
  headerTitle?: string;
  imageRef?: string;
  imageWidth?: string;
  isMainHeader?: boolean;
  message?: string | SafeHtml;
  redirect?: string;
  screenTitleAnalytics?: string;
  stepErrorAnalytics?: string;
  stepSuccessAnalytics?: object;
  submessage?: string | SafeHtml;
  subtitle?: string;
  tip?: string | SafeHtml;
  title?: string;
  user?: string;
}

export interface FamilyButton {
  action?: () => void;
  color?: string;
  fill?: 'clear' | 'solid';
  redirect?: string;
  text: string;
}
